<template>
  <div id="layout">
    <Sidebar  :visible.sync="menuOpen">
      <div class="__menu">
        <div class="__nav">
          <router-link v-if="userProfile.approved" @click.native="closeMenu()" to="/orders" class="link">Orders</router-link>
          <router-link @click.native="closeMenu()" to="/facility" class="link">Facility</router-link>
          <div v-if="userProfile.role != 'customer'" class="separator"></div>
          <span v-if="userProfile.role != 'customer'">
            <router-link @click.native="closeMenu()" to="/admin" class="link">Admin</router-link>
          </span>
          <div class="separator"></div>
          <div class="link signout" @click="signOut()">Signout</div>
        </div>
        <div class="filler"></div>
        <div class="__lower">
          <router-link @click.native="closeMenu()" to="/survey" class="feedback">Feedback?</router-link>
          <div class="logo"></div>
          <router-link class="user_cont" to="/profile" @click.native="closeMenu()">
            <div class="avatar"></div>
            <div>
              <div class="name">{{userProfile.firstname}} {{userProfile.lastname}}</div>
              <div class="role">{{userProfile.role}}</div>
            </div>
          </router-link>
        </div>
      </div>
    </Sidebar>
    <div class="topbar">
      <Button @click="menuOpen = true" class="menu_button_cont p-button-rounded p-button-text">
        <div class="menu_button"></div>
      </Button>
      <div class="title">{{$route.name}}</div>

    </div>
    <div :class="$route.meta.orderRoute ? 'order_content' : '__content'">
      <router-view/>
    </div>
  </div>
</template>

<script>
import { fb_auth, fb_db, fb_users } from '../firebase'
import Tooltip from 'primevue/tooltip';
import Sidebar from 'primevue/sidebar';

export default {
  name: "Layout",
  directives: {
    'tooltip': Tooltip
  },
  components: {
    Sidebar,
  },
	data() {
		return {
      menuOpen: false,
    }
  },
  async mounted () {
    
  },
  methods: {
    closeMenu() {
      this.menuOpen = false;
    },
    signOut() {
      this.menuOpen = false;
      setTimeout(() => {
        fb_auth.signOut()
        .then(()=>{
          this.$store.dispatch('clearData');
          this.$router.push('/');
        });
      }, 300);
    },
    getApproved() {
      return this.$store.state.userProfile.approved
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser; 
    },
    userProfile() {
      return this.$store.state.userProfile; 
    },
    config() {
      return this.$store.state.config;
    }
  },
}
</script>

<style lang="scss">
@import "@/assets/theme.scss";

#layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: $white;
  overflow: hidden;

  .menu_button {
    background: url('../assets/menu.png') no-repeat center center;
    background-size: contain;
    width: 25px;
    height: 25px;
  }

  .__menu {
    margin-left: 10px;
    text-align: left;
    display: flex;
     flex-flow: column wrap;
    height: 95vh;

    .__nav {

      .link {
        font-size: 26px;
        font-weight: 700;
        color: $text;
        text-decoration: none;
        display: block;
        margin: 20px 0px;
      }

      .router-link-exact-active {
        color: $primary;
      }

      .separator {
        width: 85%;
        height: 2px;
        background: #ffc400;
        margin: 15px 0px 30px 0px;
      }

      .signout {
        cursor: pointer;
      }

    } //.__nav

    .filler {
      flex-grow: 1;
    }

    .__lower {

      .logo {
        background: url('../assets/se_text_logo.png') no-repeat center center;
        background-size: contain;
        height: 85px;
        width: 186px;
      }

      .feedback {
        position: relative;
        top: -20px;
      }

      .user_cont {
        display: flex;
        padding-top: 30px;
        text-align: left;

        .avatar {
          width: 60px;
          height: 60px;
          margin: 5px;
          border-radius: 60px;
          line-height: 60px;
          text-align: center;
          color: white;
          background: url('../assets/user.png') #3a3a3a center center no-repeat;
          background-size: 35px 35px;
        }

        .name {
          font-size: 18px;
          padding-top: 10px;
          margin-left: 20px;
        }

        .role {
          font-size: 14px;
          margin-left: 20px;
          text-transform: capitalize;
        }

      } //.user_cont

    } //.__lower

  } //.__menu

  .topbar {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 75px;
    background: $primary;
    position: fixed;
    width: 100%;

    .menu_button_cont {
      margin-top: 15px;
      margin-left: 10px;
      align-self: flex-start;
    }

    .title {
      text-align: center;
      position: absolute; 
      line-height: 75px;
      color: $white;
      font-weight: 600;
      text-transform: uppercase; 
    }
  }

  .__content {
    overflow-y: scroll;
    position: absolute;
    width: 100%;
    height: calc(100% - 75px);
    top: 74px;
  }

  .order_content {
    overflow-y: hidden;
    position: absolute;
    width: 100%;
    height: calc(100% - 75px);
    top: 75px;
  }

}
</style>